<template>
    <div aria-labelledby="confirmationModal" class="modal fade" id="confirmationModal" ref="modal" role="dialog"
         tabindex="-1">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                            <path d="M0 0h24v24H0z" fill="none"/>
                        </svg>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="d-flex justify-content-center align-content-center mb-3">
                        <font-awesome-icon :icon="icon" style="width: 100px; height: 100px;"/>
                    </div>
                    <div class="text-center mb-3" v-html="message"></div>
                </div>

                <div class="modal-footer d-flex justify-content-between" v-if="showButtons">
                    <button
                        @click.prevent="cancelAndClose"
                        class="btn btn-info"
                        v-if="showClose"
                    >
                        {{ __('Cancel') }}
                    </button>

                    <button
                        @click.prevent="confirmAndClose"
                        class="btn btn-primary"
                        v-if="showConfirm"
                    >
                        {{ __('Confirm') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  install (Vue) {
    Vue.prototype.$modal = new (Vue.extend(this))()
    Vue.modal = Vue.prototype.$modal
  },

  computed: {
    icon () {
      if (this.theme === 'info') {
        return 'info-circle'
      }

      return 'question-circle'
    },

    showConfirm () {
      return !!this.onConfirm
    },

    showClose () {
      return !!this.onClose
    },

    showButtons () {
      return this.showConfirm || this.showClose
    }
  },

  data () {
    return {
      onConfirm: Function,
      onClose: Function,
      message: String,
      theme: String
    }
  },

  created () {
    $(this.$refs.modal).on('hidden.bs.modal', () => {
      this.onConfirm = null
      this.onClose = null
      this.message = null
      this.theme = null
    })
  },

  methods: {
    info (message) {
      this.show(message, 'info')
    },

    confirm (message, onConfirm = null, onClose = () => {
    }) {
      this.show(message, 'confirm', onConfirm, onClose)
    },

    show (message, theme, onConfirm = null, onClose = null) {
      this.mountIfNotMounted()

      this.message = message
      this.theme = theme
      this.onConfirm = onConfirm
      this.onClose = onClose

      $(this.$refs.modal).modal('show')
    },

    confirmAndClose () {
      if (this.onConfirm) this.onConfirm()
      $(this.$refs.modal).modal('hide')
    },

    cancelAndClose () {
      if (this.onClose) this.onClose()
      $(this.$refs.modal).modal('hide')
    },

    mountIfNotMounted () {
      if (!this.$parent) {
        this.$mount()
        document.body.appendChild(this.$el)
      }
    }
  }
}
</script>
